import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Container from '../../../../components/Container';

export const useStickySentinel = () => {
  const sentinelRef = React.useRef(null);

  return {
    sentinelNode: <div ref={sentinelRef} className="sticky-sentinel" />,
    sentinelRef,
  };
};

const DashboardStickyHeader = ({ title, controls, icons, actions, tabs, isSticky = false }) => (
  <div className="dashboard-sticky-header__outer">
    <div
      className={cx('dashboard-sticky-header', { 'dashboard-sticky-header--visible': isSticky })}
    >
      <div className="dashboard-sticky-header__row">
        <Container maxWidth={1128}>
          <div className="dashboard-sticky-header__content">
            <div className="dashboard-sticky-header__left">
              <span className="dashboard-sticky-header__title">{title}</span>
              {controls}
            </div>
            <div className="dashboard-sticky-header__right">
              {icons}
              {actions}
            </div>
          </div>
        </Container>
      </div>
      {tabs}
    </div>
  </div>
);

DashboardStickyHeader.propTypes = {
  title: T.string.isRequired,
  controls: T.node,
  icons: T.node,
  actions: T.node,
  tabs: T.node.isRequired,
  isSticky: T.bool,
};

export default DashboardStickyHeader;
